import './kp-main-menu-logo.less';

import MainMenuComponent from '../main-menu/kp-main-menu.component';

/**
 * @ngdoc component
 * @name kpMainMenuLogo
 * @module portaro.components.main-menu
 *
 * @description
 * Wrapper around logo which is transcluded.
 *
 * # Requires
 * {@link component:kpMainMenu ^^kpMainMenu}
 *
 * @param {boolean=} alwaysVisible Default `false`. If `true` then logo will be visible always, otherwise logo will be visible
 *                    only if {@link component:kpMainMenu kpMainMenu} is sticked
 */
export default class MainMenuLogoComponent {
    static componentName = 'kpMainMenuLogo';

    template = `
        <div class="kp-main-menu-logo" ng-class="{'logo-visible': mmlc.mainMenuController.isSticked || mmlc.alwaysVisible}" kp-on-transition-end="mmlc.mainMenuController.checkOverflowing()" kp-on-transition-end-properties="max-width" ng-transclude></div>
    `;
    transclude = true;
    require = {
        mainMenuController: `^^${MainMenuComponent.componentName}`
    };
    bindings = {
        alwaysVisible: '<'
    };
    controllerAs = 'mmlc';
}